import {
  EnumMyCourseMenu,
  EnumMyStudyMenu,
  EnumMyAccountMenu,
  EnumMySettingsMenu,
  EnumMyTabs,
  EnumMyAccountPacksFilter
} from '@xt/client/enums/my'
import { EnumSearchStudyProgress } from '@xt/client/enums/product'
import { MenuFilter } from '@xt/client/entities/my-v2/types'
import { EnumContentType, EnumSearchProductType } from '@xt/client/enums/product'

export const dataSource_My = {
  sexOptions: [
    { label: '男', value: 1 },
    { label: '女', value: 2 }
  ],
  industryOptions: [
    { value: 20, label: '教育' },
    { value: 21, label: '文化艺术' },
    { value: 82, label: '互联网' },
    { value: 84, label: '传媒' },
    { value: 85, label: '金融' },
    { value: 86, label: '政府机关' },
    { value: 87, label: '其他' }
  ],
  careerOptions: [
    { value: 22, label: '教师' },
    { value: 23, label: '医生' },
    { value: 90, label: '工程师' },
    { value: 91, label: '程序员' },
    { value: 92, label: '公务员' },
    { value: 93, label: '创业者' },
    { value: 94, label: '管理者' },
    { value: 95, label: '职员' },
    { value: 96, label: '退休' },
    { value: 97, label: '自由职业' },
    { value: 98, label: '家庭主妇' },
    { value: 99, label: '学生' },
    { value: 100, label: '其他' }
  ],

  educationOptions: [
    { value: 24, label: '高中及以下' },
    { value: 25, label: '专科' },
    { value: 26, label: '本科' },
    { value: 88, label: '硕士' },
    { value: 89, label: '博士及以上' }
  ]
}

export const myCourseMenu: Array<MenuFilter> = [
  {
    label: '全部课程',
    value: '',
    filters: [
      { value: '', label: '全部' },
      { value: EnumContentType.Calligraphy.toString(), label: '书法' },
      { value: EnumContentType.Painting.toString(), label: '国画' },
      { value: EnumContentType.CalligraphyAndReading.toString(), label: '书画' },
      { value: EnumContentType.AestheticEducation.toString(), label: '美育' }
    ]
  },
  {
    label: '林曦老师亲授',
    value: EnumMyCourseMenu.Teach,
    filters: [
      { value: '', label: '全部' },
      { value: EnumSearchProductType.Series.toString(), label: '系列课' },
      { value: EnumSearchProductType.SpecialTopic.toString(), label: '专题课' }
    ]
  },
  {
    label: '林曦老师监制',
    value: EnumMyCourseMenu.Product,
    filters: [
      { value: '', label: '全部' },
      { value: EnumSearchProductType.DayCourse.toString(), label: '教练日课' },
      { value: EnumSearchProductType.SelfStudy.toString(), label: '自习课' },
      { value: EnumSearchProductType.StudyExhibition.toString(), label: '暄桐展览' }
    ]
  }
  // {
  //   label: '线下课',
  //   value: EnumMyCourseMenu.Offline,
  //   filters: []
  // }
]

export const myStudyMenu = [
  { label: '作业', value: EnumMyStudyMenu.Homework },
  {
    label: '作品',
    value: EnumMyStudyMenu.Reward
  },
  {
    label: '日常',
    value: EnumMyStudyMenu.Daily
  },
  {
    label: '收藏',
    value: EnumMyStudyMenu.Collect
  }
]

export const myAccountMenu = [
  { label: '订单', value: EnumMyAccountMenu.Order },
  {
    label: '笔山',
    value: EnumMyAccountMenu.Bishan
  },
  {
    label: '桐板儿',
    value: EnumMyAccountMenu.Coin
  },
  {
    label: '卡劵',
    value: EnumMyAccountMenu.Packs
  },
  {
    label: '积分兑换',
    value: EnumMyAccountMenu.Exchange
  }
]

export const mySettingsMenu = [
  { label: '个人资料', value: EnumMySettingsMenu.Myself },
  { label: '通知消息', value: EnumMySettingsMenu.Notice },
  { label: '账号设置', value: EnumMySettingsMenu.Account }
]

export const myTabsList: Array<{ key: EnumMyTabs; path: string; display: boolean }> = [
  { key: EnumMyTabs.Index, path: 'my', display: true },
  { key: EnumMyTabs.Course, path: 'my-course', display: true },
  { key: EnumMyTabs.Study, path: 'my-study', display: true },
  { key: EnumMyTabs.Account, path: 'my-account', display: true },
  { key: EnumMyTabs.Settings, path: 'my-settings', display: false }
]

export const myAccountPacksFilter: Array<{
  key: EnumMyAccountPacksFilter
  title: string
}> = [
  { key: EnumMyAccountPacksFilter.All, title: '全部' },
  { key: EnumMyAccountPacksFilter.WelfareCoupon, title: '福利券' },
  { key: EnumMyAccountPacksFilter.WenfangCoupon, title: '文房券' },
  // { key: EnumMyAccountPacksFilter.CompanionCard, title: '伴学卡' }
  { key: EnumMyAccountPacksFilter.Used, title: '已使用' },
  { key: EnumMyAccountPacksFilter.Expired, title: '已过期' }
]

export const myCourseStudyProgress = [
  { label: '全部', value: '', selectionLabel: '全部进度' },
  { label: '未开始', value: EnumSearchStudyProgress.NotStart.toString(), selectionLabel: '未开始' },
  { label: '开课中', value: EnumSearchStudyProgress.InProgress.toString(), selectionLabel: '开课中' },
  { label: '已结课', value: EnumSearchStudyProgress.End.toString(), selectionLabel: '已结课' }
]

export const myAccountExchangeFilter: Array<{
  key: number
  title: string
}> = [
  { key: EnumMyAccountPacksFilter.All, title: '全部' },
  { key: EnumMyAccountPacksFilter.WelfareCoupon, title: '福利券' },
  { key: EnumMyAccountPacksFilter.WenfangCoupon, title: '文房券' }
  // { key: EnumMyAccountPacksFilter.CompanionCard, title: '伴学卡' }
]
